import { faX } from "@fortawesome/pro-solid-svg-icons/faX";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ActionIcon, Divider, Flex, Radio, Text } from "@mantine/core";

import { useFilterAnalytics } from "@/hooks/analytics.hooks";
import type { FilterableCompetencyFits } from "@/types/api";
import { CompetencyFit } from "@/types/screeners";

const COMPETENCY_FIT_OPTIONS: {
  display: string;
  value: FilterableCompetencyFits;
}[] = [
  {
    display: "Very High",
    value: CompetencyFit.VeryHigh,
  },
  { display: "At Least High", value: CompetencyFit.High },
  {
    display: "At Least Medium",
    value: CompetencyFit.Medium,
  },
];

interface CompetencyFitFilterProps {
  label: string;
  onChange: (value: FilterableCompetencyFits) => void;
  onClear: () => void;
  value: FilterableCompetencyFits | null;
}

export const CompetencyFitFilter = ({
  label,
  onChange,
  onClear,
  value,
}: CompetencyFitFilterProps) => {
  const trackFilter = useFilterAnalytics(label);

  const handleChange = (newValue: FilterableCompetencyFits) => {
    trackFilter(newValue);
    onChange(newValue);
  };

  return (
    <div className="flex flex-col gap-2 items-start justify-between my-2">
      <Divider className="w-full" />
      <Flex
        align="flex-start"
        className="min-h-7 w-full"
        justify="space-between"
      >
        <Text className="w-[calc(100%-1.75rem)]" fw={600} size="sm">
          {label}
        </Text>
        {value && (
          <ActionIcon
            onClick={onClear}
            className="min-h-min h-min mt-0.5 w-7"
            variant="transparent"
          >
            <FontAwesomeIcon icon={faX} size="sm" />
          </ActionIcon>
        )}
      </Flex>
      {COMPETENCY_FIT_OPTIONS.map(({ display, value: optionValue }) => (
        <Radio
          key={optionValue}
          name={label}
          label={display}
          onChange={() => handleChange(optionValue)}
          checked={value === optionValue}
        />
      ))}
    </div>
  );
};
